<div class="jumbotron jumbotron-fluid mb-0">
    <div class="container hero-content">
        <div class="row">
            <div class="col-lg-7">
                <h1 class="hero-title">Vom Verwalten zum Gestalten</h1>
                <p class="hero-subtitle">Einfach und effizient Bescheide und Verträge managen und digitalisieren</p>
                <div class="hero-cta">
                    <button type="button" class="btn btn-success btn-lg mr-3" [routerLink]="['/demo']"><i class="fas fa-play-circle"></i> Kostenlos testen</button>
                    <button type="button" class="btn btn-outline-primary btn-lg" [routerLink]="['/features']">Mehr erfahren</button>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="container-fluid">
    <div class="row bg-white features-section">
        <div class="container">
            <div class="row">
                <div class="col-lg-10 offset-lg-1 text-center mb-5">
                    <h2 class="section-title">Digitalisieren Sie Ihre Dokumente</h2>
                    <p class="section-description">
                        Transformieren Sie Ihr Dokumentenmanagement mit NoteRadar! Unsere leistungsstarke Plattform verwandelt Ihre <a [routerLink]="['/features']" fragment="Vertrag">Verträge</a> und <a [routerLink]="['/features']" fragment="Bescheid">Bescheide</a> in strukturierte digitale Assets, die Ihren Arbeitsalltag revolutionieren. Behalten Sie mühelos den Überblick durch ein intuitives Dashboard, das alle wichtigen Termine auf einen Blick präsentiert. Erstellen Sie maßgeschneiderte Erinnerungen für einmalige oder wiederkehrende Aufgaben und bleiben Sie stets im Zeitplan. Mit der integrierten <a [routerLink]="['/features']" fragment="Share">FileShare</a>-Funktion optimieren Sie zudem die Zusammenarbeit mit externen Partnern – sicher, schnell und unkompliziert.
                    </p>
                </div>
            </div>

            <div class="row feature-cards">
                <div class="col-md-6 col-lg-4 mb-4">
                    <div class="feature-card">
                        <div class="feature-icon">
                            <i class="fas fa-tachometer-alt" style="color: #f86c6b"></i>
                        </div>
                        <h3 class="feature-title">Schnelle Digitalisierung</h3>
                        <p class="feature-description">Revolutionieren Sie Ihre Dokumentenverwaltung! In nur 48 Stunden transformieren wir Ihre Bescheide und Verträge in ein digitales Format und strukturieren sie in übersichtliche Aufgaben – sofort einsatzbereit in Ihrem persönlichen Dashboard.</p>
                    </div>
                </div>
                <div class="col-md-6 col-lg-4 mb-4">
                    <div class="feature-card">
                        <div class="feature-icon">
                            <i class="far fa-bell" style="color: #ffc107"></i>
                        </div>
                        <h3 class="feature-title">Flexible Erinnerungen</h3>
                        <p class="feature-description">Verpassen Sie nie wieder wichtige Fristen! Unser intelligentes Erinnerungssystem passt sich Ihren Bedürfnissen an – egal ob kurzfristige Aufgaben, kritische Fälligkeiten oder langfristige Termine. Erhalten Sie punktgenaue Benachrichtigungen genau dann, wenn Sie sie brauchen.</p>
                    </div>
                </div>
                <div class="col-md-6 col-lg-4 mb-4">
                    <div class="feature-card">
                        <div class="feature-icon">
                            <i class="far fa-check-circle" style="color: #4dbd74"></i>
                        </div>
                        <h3 class="feature-title">Einfache Bedienung</h3>
                        <p class="feature-description">Sparen Sie wertvolle Zeit mit unserer intuitiven Benutzeroberfläche! Speziell entwickelt für maximale Effizienz – ohne lange Einarbeitungszeit. Die klare Struktur und durchdachte Navigation ermöglichen selbst komplexe Aufgaben mit wenigen Klicks zu erledigen.</p>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!--<div class="row" style="background: #f5f5f5">
        <div class="offset-sm-1 col-sm-10 offset-md-2 col-md-8" style="padding-top: 100px; padding-bottom: 100px">

            <h1 class="display-4 text-center mb-4"><i class="fas fa-cubes"></i> Demozugang anfordern</h1>

            <div class="row">
                <div class="col-md-12">
                    <ng-container *ngIf="!demoRequested">
                        <form class="form-inline form-demo" [formGroup]="demoForm">
                            <input type="email" class="form-control form-control-lg" placeholder="Geben Sie Ihre E-Mail ein" formControlName="email" email>
                            <button type="submit" class="btn btn-primary btn-lg ml-3" [disabled]="demoForm.invalid" (click)="requestDemo()">Anfordern</button>
                        </form>
                        <p class="mt-3">Fordern Sie einfach Ihren Demozugang an und Sie erhalten für 7 Tage Zugang zur Demo Applikation und der entsprechenden Erklärungsvideos.</p>
                    </ng-container>

                    <div class="text-center" *ngIf="demoRequested">
                        Vielen Dank! Sie erhalten in Kürze eine E-Mail mit Ihren Zugangsdaten!
                    </div>
                </div>
            </div>

        </div>
    </div>-->

    <div class="cta-section">
        <div class="container">
            <div class="row">
                <div class="col-lg-8 offset-lg-2 text-center">
                    <div class="cta-content">
                        <h2 class="section-title"><i class="fas fa-cubes cta-icon"></i> Bereit für den nächsten Schritt?</h2>
                        <p class="cta-description">Sie möchten NoteRadar einsetzen? Testen Sie unsere Plattform mit vollem Funktionsumfang oder fordern Sie ein individuelles Angebot an.</p>
                        <div class="d-flex justify-content-center flex-wrap">
                            <button type="button" class="btn btn-success btn-lg cta-button mr-3 mb-2" [routerLink]="['/demo']">
                                <i class="fas fa-play-circle"></i> Kostenlos testen
                            </button>
                            <button type="button" class="btn btn-primary btn-lg cta-button mb-2" [routerLink]="['/offer']">
                                <i class="fas fa-file-invoice"></i> Angebot anfordern
                            </button>
                        </div>
                        <p class="mt-3 small">Erstellen Sie einen kostenlosen Demozugang mit vollem Funktionsumfang für 3 Tage!</p>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="row testimonials-section">
        <div class="container">
            <div class="row">
                <div class="col-lg-10 offset-lg-1 text-center mb-5">
                    <h2 class="section-title"><i class="far fa-comment-dots testimonial-icon"></i> Was unsere Kunden sagen</h2>
                </div>
            </div>

            <div class="row">
                <div class="col-md-4 mb-4">
                    <div class="testimonial-card">
                        <div class="testimonial-image">
                            <img class="rounded-circle" alt="feedback" src="assets/img/person/person1.jpg">
                        </div>
                        <div class="testimonial-content">
                            <p class="testimonial-text">"Ich konnte durch die Einführung und der schnellen Digitalisierung meiner Verträge bereits im ersten Jahr Einsparungen umsetzen."</p>
                            <div class="testimonial-author">
                                <strong>Tischlerei</strong> <span class="testimonial-location">Salzburg</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-md-4 mb-4">
                    <div class="testimonial-card">
                        <div class="testimonial-image">
                            <img class="rounded-circle" alt="feedback" src="assets/img/person/person2.jpg">
                        </div>
                        <div class="testimonial-content">
                            <p class="testimonial-text">"Danke an das Team von NoteRadar - bis dato keine Beanstandungen der Gewerbebehörde mehr."</p>
                            <div class="testimonial-author">
                                <strong>Gastronom</strong> <span class="testimonial-location">Wien 1010</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-md-4 mb-4">
                    <div class="testimonial-card">
                        <div class="testimonial-image">
                            <img class="rounded-circle" alt="feedback" src="assets/img/person/person3.jpg">
                        </div>
                        <div class="testimonial-content">
                            <p class="testimonial-text">"Durch die Nutzung der Software konnte ich meine Verträge rechtzeitig nachverhandeln."</p>
                            <div class="testimonial-author">
                                <strong>UnternehmerIn</strong> <span class="testimonial-location">Graz</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="trust-badges-section">
        <div class="container">
            <div class="row">
                <div class="col-lg-10 offset-lg-1">
                    <div class="row trust-badges">
                        <div class="col-6 col-md trust-badge">
                            <div class="trust-badge-icon">
                                <i class="far fa-envelope-open" style="color: #4285f4"></i>
                            </div>
                            <div class="trust-badge-text">Kompetenter Fachsupport</div>
                        </div>
                        <div class="col-6 col-md trust-badge">
                            <div class="trust-badge-icon">
                                <img src="assets/img/Austria.png" alt="Austria flag">
                            </div>
                            <div class="trust-badge-text">Qualitätsprodukt aus Österreich</div>
                        </div>
                        <div class="col-6 col-md trust-badge">
                            <div class="trust-badge-icon">
                                <i class="fab fa-expeditedssl" style="color: #34a853"></i>
                            </div>
                            <div class="trust-badge-text">Sichere SSL Datenübertragung</div>
                        </div>
                        <div class="col-6 col-md trust-badge">
                            <div class="trust-badge-icon">
                                <a href="https://www.world4you.com/" target="_blank">
                                    <i class="fas fa-globe-europe" style="color: #1f79d3"></i>
                                </a>
                            </div>
                            <div class="trust-badge-text">Server in Österreich</div>
                        </div>
                        <div class="col-6 col-md trust-badge">
                            <div class="trust-badge-icon">
                                <i class="fas fa-user-secret" style="color: #333"></i>
                            </div>
                            <div class="trust-badge-text">Datenschutz garantiert</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
